// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"26d335da","806":"3e9d668e","844":"643bb5c1"}[chunkId] + ".js";
};